import { IDropdownOption } from "@fluentui/react";

// 個人情報画面: 血液型
export const BLOOD_TYPE_OPTIONS = [
  { key: '不明', text: '不明' },
  { key: 'A+', text: 'A型+' },
  { key: 'A-', text: 'A型-' },
  { key: 'B+', text: 'B型+' },
  { key: 'B-', text: 'B型-' },
  { key: 'O+', text: 'O型+' },
  { key: 'O-', text: 'O型-' },
  { key: 'AB+', text: 'AB型+' },
  { key: 'AB-', text: 'AB型-' }
];

// 個人情報画面: 連絡先関係
export const EMERGENCY_RELATION_OPTIONS = [
  { key: '親', text: '親' },
  { key: '父', text: '父' },
  { key: '母', text: '母' },
  { key: '配偶者', text: '配偶者' },
  { key: '子供', text: '子供' },
  { key: '兄弟', text: '兄弟' },
  { key: '姉妹', text: '姉妹' },
  { key: '祖父', text: '祖父' },
  { key: '祖母', text: '祖母' },
  { key: '孫', text: '孫' },
  { key: '叔父', text: '叔父' },
  { key: '叔母', text: '叔母' },
  { key: '友人', text: '友人' },
  { key: '同僚', text: '同僚' },
  { key: '上司', text: '上司' },
  { key: '近隣', text: '近隣' },
  { key: 'その他', text: 'その他' }
];

// 個人情報画面: 性別
export const GENDER_OPTIONS = [
  { key: "男性", text: "男性" },
  { key: "女性", text: "女性" },
  { key: "その他", text: "その他" },
];

// 個人情報画面: 職種
export const JOBTYPE_OPTIONS = [
  { key: '土木作業員', text: '土木作業員' },
  { key: '鳶(とび)職人', text: '鳶(とび)職人' },
  { key: '鉄筋工職人', text: '鉄筋工職人' },
  { key: '鍛冶工職人', text: '鍛冶工職人' },
  { key: '型枠大工職人', text: '型枠大工職人' },
  { key: '外壁職人', text: '外壁職人' },
  { key: '左官職人', text: '左官職人' },
  { key: '内装職人', text: '内装職人' },
  { key: '塗装職人', text: '塗装職人' },
  { key: '配管工職人', text: '配管工職人' },
  { key: '電気工事職人', text: '電気工事職人' },
  { key: '外構職人', text: '外構職人' },
  { key: '大工', text: '大工' },
  { key: 'その他', text: 'その他' }
];

// 個人情報画面: 保有資格
export const QUALIFICATION_OPTIONS = [
  { key: '高所作業者', text: '高所作業者' },
  { key: '玉掛け技能者', text: '玉掛け技能者' },
  { key: '足場の組立・解体作業者', text: '足場の組立・解体作業者' },
  { key: '溶接作業者', text: '溶接作業者' },
  { key: 'フォークリフト運転者', text: 'フォークリフト運転者' },
  { key: '電気工事士', text: '電気工事士' },
  { key: '土木施工管理技士', text: '土木施工管理技士' },
  { key: '建築施工管理技士', text: '建築施工管理技士' },
  { key: '危険物取扱者', text: '危険物取扱者' },
  { key: 'ガス溶接作業者', text: 'ガス溶接作業者' },
  { key: 'コンクリート圧送作業者', text: 'コンクリート圧送作業者' },
  { key: '舗装施工管理技士', text: '舗装施工管理技士' },
  { key: '解体工事作業者', text: '解体工事作業者' }
];

// 新規入場画面: 今日の体調
export const CONDITION_OPTIONS = [
  { key: "Good", text: "良好" },
  { key: "Tired", text: "疲労" },
  { key: "NotWell", text: "体調不良" }
];

// 新規入場画面: あなたの役割
export const ROLE_OPTIONS = [
  { key: 'height', text: '高所作業' },
  { key: 'hotwork', text: 'ホットワーク' }, 
  { key: 'confined', text: '閉鎖空間への立ち入り' }, 
  { key: 'scaffolding', text: '足場作業' },
  { key: 'electrical', text: '電気工事' },
  { key: 'plumbing', text: '配管工事' },  
  { key: 'demolition', text: '解体作業' }, 
  { key: 'welding', text: '溶接作業' },
  { key: 'painting', text: '塗装作業' },   
  { key: 'materialhandling', text: '資材取り扱い' }, 
  { key: 'lifting', text: 'クレーン等による荷揚げ' },
  { key: 'excavation', text: '掘削作業' },  
  { key: 'trafficcontrol', text: '交通誘導' }, 
  { key: 'other', text: 'その他' }   
];

// 新規入場画面: 怪我などの状況
export const INJURY_OPTIONS = [
  { key: "none", text: "無し" },
  { key: "minor", text: "軽傷" },
  { key: "serious", text: "要診察" },
];

// 新規入場画面: 今日の血圧
export const BLOOD_PRESSURE_OPTIONS = [
  { key: "Systolic", text: "収縮期 (上段: 80-200 mmHg)" },
  { key: "Diastolic", text: "拡張期 (下段: 40-120 mmHg)" },
  { key: "Normal", text: "標準値 約 120/80 mmHg" },
  { key: "High", text: "高血圧傾向" },
  { key: "Low", text: "低血圧傾向" }
];

// 新規入場画面: 今日の体温
export const BODY_TEMP_OPTIONS = [
  { key: "normal", text: "平熱 (36〜37℃)" },
  { key: "mild", text: "微熱 (37〜38℃)" },
  { key: "fever", text: "発熱 (38℃ 以上)" },
];

// 新規入場画面: 協力業者様
export const ALL_CONTRACTORS_OPTIONS: IDropdownOption[] = [
   { key: "1", text: "東和建設　外壁補修工事" },   // Towa Construction – Exterior Wall Repair
  { key: "2", text: "山田組　屋根防水工事" },     // Yamada Group – Roof Waterproofing
  { key: "3", text: "北斗興業　電気設備工事" },   // Hokuto Industries – Electrical Installation
  { key: "4", text: "西村建設　基礎工事" },       // Nishimura Construction – Foundation Work
  { key: "5", text: "桜工務店　配管設備工事" },   // Sakura Contractors – Plumbing Installation
  { key: "6", text: "東洋技建　内装仕上工事" },   // Toyo Engineering – Interior Finishing
  { key: "7", text: "旭興業　足場解体" },         // Asahi Industries – Scaffold Dismantling
  { key: "8", text: "新星建築　塗装工事" },       // Shinsei Builders – Painting Work
  { key: "9", text: "大関興行　外装工事" },        // Yamato Construction Co., Ltd.
  { key: "10", text: "大関興行　内装工事" },        // Toyo Builders
  { key: "11", text: "大口建設　足場組立" },  // Fuji Skyline Contractors
 
];

// KY活用画面 : 危険作業
export const RISKY_WORK_OPTIONS: IDropdownOption[] = [
  { key: 'height', text: '高所作業' }, 
  { key: 'confined', text: '閉鎖空間への立ち入り' },
  { key: 'hotwork', text: 'ホットワーク（溶接・切断など）' },
  { key: 'electrical', text: '電気設備作業' }, 
  { key: 'crane', text: 'クレーン操作・荷揚げ作業' },
  { key: 'demolition', text: '解体作業' },
  { key: 'excavation', text: '掘削作業' },
  { key: 'welding', text: '溶接作業' }, 
  { key: 'flammable', text: '可燃物作業' },
  { key: 'heavyload', text: '重量物取り扱い' }, 
  { key: 'movingmachinery', text: '可動機械作業' },
  { key: 'confinedheight', text: '高所での閉鎖空間作業' },
  { key: 'other', text: 'その他危険作業' }
];

// KY活用画面 : 危険回避策
export const RISK_MEASURE_MAP: Record<string, IDropdownOption[]> = {
  height: [
    { key: 'height1', text: '安全帯を使用する' },
    { key: 'height2', text: 'ガードレールを設置する' },
  ],
  hotwork: [
    { key: 'hotwork1', text: '消火器を近くに置いておく' },
    { key: 'hotwork2', text: '可燃物を取り除く' },
  ],
  confined: [
    { key: 'confined1', text: '空気の質をテストする' },
    { key: 'confined2', text: 'ガス検知器を使用する' },
  ],
};